import Briefcase from '../assets/images/briefcase.png';
import RexlabsLogo from '../assets/images/rexlabs.svg';
import SerenadeLogo from '../assets/images/Serenade_500x500px.jpeg';
import VeChainLogo from '../assets/images/vechain.png';

export interface JourneyMetric {
  value: string;
  label: string;
}

export interface JourneyEntry {
  id: string;
  company: string;
  category: string;
  role: string;
  period: string;
  storyTitle: string;
  story: string;
  metrics?: JourneyMetric[];
  image: string;
  imageAlt: string;
}

const engineeringJourney: JourneyEntry[] = [
  {
    id: 'rex-software',
    company: 'Rex Software',
    category: 'Real estate',
    role: 'Software Developer',
    period: '2018–2021',
    storyTitle: 'Close to the customer, close to the problem.',
    story:
      'I began at Rex, helping real estate agencies move their teams and data onto the platform. Working across customers, product and engineering taught me how to turn messy real-world needs into software people could rely on.',
    metrics: [
      { value: '100+', label: 'agencies onboarded' },
      { value: '1M+', label: 'properties migrated' },
      { value: 'AU → UK', label: 'expansion supported' },
    ],
    image: RexlabsLogo,
    imageAlt: 'Rex Software logo',
  },
  {
    id: 'serenade',
    company: 'Serenade',
    category: 'Music',
    role: 'Software / Blockchain Developer',
    period: '2022–2024',
    storyTitle: 'Then music met smart contracts.',
    story:
      'At Serenade, I helped turn blockchain music from an idea into something artists and fans could actually use. Digital Pressing became the first format of its kind recognised by the UK Official Charts and ARIA, powering releases for more than 200 artists and partners.',
    metrics: [
      { value: 'First', label: 'chart-recognised format' },
      { value: '200+', label: 'artists and partners' },
      { value: 'The Guardian', label: 'media coverage' },
    ],
    image: SerenadeLogo,
    imageAlt: 'Serenade logo',
  },
  {
    id: 'vechain',
    company: 'VeChain',
    category: 'Layer 1 blockchain',
    role: 'Senior Software / Blockchain Developer',
    period: '2025–2026',
    storyTitle: 'From community idea to everyday feature.',
    story:
      'At VeChain, I noticed people had to return and repeat the same vote every week. I proposed a simpler approach, earned community backing and helped ship auto-voting, alongside clearer account restrictions and a fairer appeal process.',
    metrics: [
      { value: '18,000+', label: 'governance voters' },
      { value: '1,100+', label: 'users in two months' },
      { value: '400+', label: 'users reinstated' },
    ],
    image: VeChainLogo,
    imageAlt: 'VeChain logo',
  },
  {
    id: 'uphold',
    company: 'Uphold',
    category: 'Wallet & custody',
    role: 'Senior Backend Engineer',
    period: '2026–Present',
    storyTitle: 'Deeper into the financial plumbing.',
    story:
      'Now at Uphold, I lead Open Banking work and improve the integrations that move money between banks and the platform. It is mostly invisible work, but reliability matters most when real money is moving.',
    image: Briefcase,
    imageAlt: 'Briefcase',
  },
];

export default engineeringJourney;
